module.exports = __webpack_public_path__ + "static/media/image (32).891131e9.jpg";